export const filterType = {
    default: 'Default',
    slider: 'Slider'
 }
 